import { CustomEvents } from "@core/ui";
import { onCleanup, onMount } from "solid-js";

export const useThreadAutoScroll = (getScrollableContainer: () => HTMLElement | null) => {
  onMount(() => {
    const listener = () => {
      const scrollableContainer = getScrollableContainer();
      if (!scrollableContainer) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          scrollableContainer.scrollTo({
            top: scrollableContainer.scrollHeight,
            behavior: "smooth",
          });
        });
      });
    };
    CustomEvents.threadResponseReceived.add(listener);
    onCleanup(() => {
      CustomEvents.threadResponseReceived.remove(listener);
    });
  });
};
